module.exports = __webpack_public_path__ + "static/media/b1.4b24cc20.png";